export const defaultLocale = 'tr'
export const localeOptions = [
  { id: 'tr', name: 'Türkçe', direction: 'ltr' },
  { id: 'en', name: 'English', direction: 'ltr' }
]